import 'bootstrap'
import HeroAnimation from './HeroAnimation'

let animatedText = document.getElementById('hero-animated-text')
new HeroAnimation(animatedText)

const cards = document.querySelectorAll('.portfolio-card')
cards.forEach(card => card.classList.add('reveal'))

const observer = new IntersectionObserver(
    entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible')
            observer.unobserve(entry.target)
        }
    }),
    { threshold: 0.15 }
)
cards.forEach(card => observer.observe(card))

const navbar = document.querySelector('nav.navbar')
window.addEventListener('scroll', () => {
    navbar.classList.toggle('navbar-scrolled', window.scrollY > 60)
})